export const USER_LOG_REPORT_DATA = 'USER_LOG_REPORT_DATA'
export const PREPOND_POSTPOND_GNREPORT = 'PREPOND_POSTPOND_GNREPORT'
export const PREPOND_POSTPOND_ACREPORT = 'PREPOND_POSTPOND_ACREPORT'
export const UPDATE_BOOKING_TYPE = 'UPDATE_BOOKING_TYPE'
export const UPDATE_GENAI_REPORT = 'UPDATE_GENAI_REPORT'
